import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";

function EditUnit() {
  const [unitName, setUnitName] = useState("");
  const [current, setCurrent] = useState("");
  const [unitError, setUnitError] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const currentOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];
  let navigate = useNavigate();

  const { id } = useParams();
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-unit/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        setUnitName(response.data.UnitName);
        setCurrent(String(response.data.Current));
      }
    }
    fetchData();
  }, []);

  const editUnit = async(e) => {
    e.preventDefault();

    // Validate input fields
    if (unitName === "") {
      setUnitError(true)
      return false;
    }

    let URL = process.env.REACT_APP_API_URL + "/update-unit";
    let payload = { UnitName: unitName, Current: parseInt(current), UnitID: id };
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if(response?.data){
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/units");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    }else{
      setMessage(response?.error?.message || 'Failed to update unit !!');
      setMessageType('error');
    }
  };
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav style={{ ariaLabel: "breadcrumb" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/units"
                    className="text-decoration-none text-primary"
                  >
                    Units
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit Unit
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Edit Unit</h1>
                  {/* <p className="text-lite fs-15 mb-0">
                    Please enter details to add new unit
                  </p> */}
                </div>
                <form onSubmit={editUnit}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Unit Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (unitError ? " is-invalid" : "")
                          }
                          placeholder="Enter Unit Name"
                          onChange={(e) => {
                            setUnitError(false)
                            setUnitName(e.target.value);
                          }}
                          value={unitName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md"
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                          value={current}
                        >
                          {currentOptions.map((option, key) => {
                            return (
                              <option
                                value={option.value}
                                defaultValue={current}
                                key={key}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Edit Unit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default EditUnit;
